import { TableTitle, TableHead as UITableHead } from '@genial/components';
import React from 'react';

import { tableHeadAlignments } from './constants';

interface TableHeadProps {
  tableHead: {
    [key: string]: string;
  };
  widthCols: { [key: string]: { desktop: number; tablet: number } };
}

export const TableHead: React.FC<TableHeadProps> = ({ tableHead, widthCols }) => {
  const items = Object.entries(tableHead);

  const Content = items.map((item, index) => (
    <TableTitle
      key={item[0]}
      testID={`table-head-title-${index}`}
      width={widthCols[item[0]].desktop}
      textAlign={tableHeadAlignments[item[0]]}>
      {item[1] as string}
    </TableTitle>
  ));

  return (
    <UITableHead display={{ base: 'none', lg: 'flex' }} testID="table-pension-statements-head">
      {Content}
    </UITableHead>
  );
};
